export const SuperCounter = ({ value = '' }) => {
  const status = {
    ERROR: 'error',
    WARNING: 'warning',
    SUCCESS: 'success',
    LIMIT: 'limit',
  }

  const translations = {
    [status.ERROR]: 'Write a few words',
    [status.WARNING]: 'Write a little more!',
    [status.SUCCESS]: 'Perfect!',
    [status.LIMIT]: "That's a little long",
  }

  const getStatusGivingRanges = (ranges) => (value) =>
    ({
      [value >= ranges[0]]: status.WARNING,
      [value >= ranges[1]]: status.SUCCESS,
      [value >= ranges[2]]: status.LIMIT,
    }[true] || status.ERROR)

  const ranges = [10, 31, 58]

  const getStatusGivenRanges = getStatusGivingRanges(ranges)

  return <span>{translations[getStatusGivenRanges(value.length)]}</span>
}
